export default __webpack_public_path__ + "static/media/Quiken_Automovil-17.01eb1ee9.svg";